// extracted by mini-css-extract-plugin
export default {"modal":"app-teams-AddTeamMemberModal-AddTeamMemberModal-module__hA6T0kwgwdVnQHbEAm_5"};